import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getI18nValue } from 'utils/Utils';
import Datepicker from 'components/actions/DatePicker';
import ExportXLSX from 'components/actions/ExportXLSX';
import useAnalyticsExport from 'hooks/useAnalyticsExport';
import ChannelSelect from './ChannelSelect';
import LanguageSelect from './LanguageSelect';
import ExportSectionPickerModal from './ExportSectionPickerModal';

function AnalyticsExportBar() {
    const { t } = useTranslation();

    const [exportDateRanges, setExportDateRanges] = useState({
        startDate: new Date(new Date().setDate(new Date().getDate() - 30)),
        endDate: new Date(),
        key: 'selection',
    });
    const [exportChannel, setExportChannel] = useState('');
    const [exportLanguage, setExportLanguage] = useState('');
    const [isPickerOpen, setIsPickerOpen] = useState(false);

    const { exportReport, isExporting } = useAnalyticsExport({
        dateRanges: exportDateRanges,
        channel: exportChannel,
        language: exportLanguage,
    });

    return (
        <>
            <div className="flex items-center gap-2 flex-wrap mb-6 p-4 bg-white shadow-sm rounded-sm border border-gray-200">
                <span className="text-sm font-semibold text-gray-700 mr-2">
                    {t(getI18nValue('analytics.export', 'title'))}
                </span>
                <Datepicker callBack={setExportDateRanges} />
                <ChannelSelect value={exportChannel} onChange={setExportChannel} />
                <LanguageSelect value={exportLanguage} onChange={setExportLanguage} />
                <ExportXLSX disabled={isExporting} onExport={() => setIsPickerOpen(true)} />
            </div>

            <ExportSectionPickerModal
                open={isPickerOpen}
                onClose={() => setIsPickerOpen(false)}
                onExport={(sections) => {
                    exportReport(sections);
                }}
                isExporting={isExporting}
            />
        </>
    );
}

export default AnalyticsExportBar;
